import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AssessmentIcon from '@material-ui/icons/Assessment';
import DnsIcon from '@material-ui/icons/Dns';
import ExtensionIcon from '@material-ui/icons/Extension';
import TimelineIcon from '@material-ui/icons/Timeline';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Rendered as an eager route link below.

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />}>
            <SidebarItem icon={SearchIcon} to="/search" text="Search" />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:catalog')}
            <SidebarItem icon={ExtensionIcon} to="/api-docs" text="APIs" />
            <SidebarItem
              icon={AssessmentIcon}
              to="/factory-products"
              text="Factory Products"
            />
            <SidebarItem
              icon={ExtensionIcon}
              to="/backstage-capabilities"
              text="Backstage Capabilities"
            />
            {nav.take('page:scaffolder')}
            {nav.take('page:catalog-import')}
            {nav.take('page:techdocs')}
            <SidebarItem icon={DnsIcon} to="/kubernetes" text="Kubernetes" />
            <SidebarItem
              icon={AccountTreeIcon}
              to="/factory-workflows"
              text="Factory Workflows"
            />
            <SidebarItem
              icon={VerifiedUserIcon}
              to="/release-evidence"
              text="Release Evidence"
            />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Insights" icon={<TimelineIcon />}>
            {nav.take('page:catalog-graph')}
            <SidebarItem
              icon={AccountTreeIcon}
              to="/product-visualizer"
              text="Product Visualizer"
            />
            <SidebarItem
              icon={TimelineIcon}
              to="/tech-radar"
              text="Tech Radar"
            />
            {nav.take('page:catalog-unprocessed-entities')}
            <SidebarItem
              icon={AssessmentIcon}
              to="/project-insights"
              text="Project Insights"
            />
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
